import BinderCostRecordsPage from './BinderCostRecordsPage';
import BinderDeliveriesPage from './BinderDeliveriesPage';
import BinderSuppliersPage from './BinderSuppliersPage';
import EditBinderCostRecordPage from './EditBinderCostRecordPage';
import EditBinderDeliveryPage from './EditBinderDeliveryPage';
import NewBinderCostRecordPage from './NewBinderCostRecordPage';
import NewBinderDeliveryPage from './NewBinderDeliveryPage';
import ApprovalPresetGroupsPage from './ApprovalPresetGroupsPage';
import NewPourPage from './NewPourPage';
import CustomReportsPage from './CustomReportsPage';
import CustomReportTemplatesPage from './CustomReportTemplatesPage';
import PourDetailsPage from './PourDetailsPage';
import PourPresetGroupsPage from './PourPresetGroupsPage';
import ProjectAreaPage from './ProjectAreaPage';
import EditRheologyPage from './ProjectAreaPage/ProjectDetailsPage/EditRheologyPage';
import EditProjectPage from './ProjectAreaPage/ProjectDetailsPage/EditProjectPage';
import NewRheologyPage from './ProjectAreaPage/ProjectDetailsPage/NewRheologyPage';
import ProjectsPage from './ProjectsPage';
import QAQCTablePage from './QAQCTablePage';
import StopeNotePage from './StopeNotePage';

const projectModule = {
  pages: [
    NewPourPage,
    CustomReportsPage,
    CustomReportTemplatesPage,
    PourDetailsPage,
    StopeNotePage,
    ProjectsPage,
    ProjectAreaPage,
    NewBinderCostRecordPage,
    BinderCostRecordsPage,
    BinderDeliveriesPage,
    BinderSuppliersPage,
    NewBinderDeliveryPage,
    EditBinderDeliveryPage,
    EditBinderCostRecordPage,
    ApprovalPresetGroupsPage,
    NewRheologyPage,
    EditProjectPage,
    EditRheologyPage,
    PourPresetGroupsPage,
    QAQCTablePage,
  ],
};

export default projectModule;
